/* import __COLOCATED_TEMPLATE__ from './blade-banner.hbs'; */
import Component from '@glimmer/component';
import { BalanceReportItemDetail } from '@square/dashboard-protos/models/squareup/balancereporter/model';
export default class Banner extends Component {
  get variant() {
    return BalanceReportItemDetail.Banner.Variant[this.args.banner.variant].toLowerCase();
  }
}